import { Platform } from "@enums/common.enum";
import type { IPlatformAdapter } from "../platform.type";
import { auth } from "./auth";

export const platform: IPlatformAdapter = {
  auth,
  current: Platform.OUTLOOK,
};
